export var ETenantCategory;
(function (ETenantCategory) {
    ETenantCategory["COLLEGE"] = "COLLEGE";
    ETenantCategory["CORPORATE"] = "CORPORATE";
    ETenantCategory["AI_COACH"] = "AI_COACH";
})(ETenantCategory || (ETenantCategory = {}));
export const othersColorPalette = {
    whiteColor: "#ffffff",
    primaryGradientColor: "linear-gradient(180deg, rgba(102, 45, 145, 0.3) 0%, rgba(217, 181, 243, 0.15) 96.35%)",
    lightPink: "rgba(255, 145, 77, 0.25)",
    lightPurple: "#460D71",
    primaryGray: "#dadada",
    darkGray: "#606060",
    dangerColor: "#BE1414",
    blackColor: "#000000",
    darkGreen: "#189A6D",
    lightGreen: "#06B657",
    redColor: "#F11E1E",
    backgroundBlack: "#1F1F1F",
    backgroundSecondaryBlack: "#505050",
    darkBorderColor: "#828282",
    backgroundTertiaryBlack: "#777777",
    successColor: "#008000",
    secondaryGrayColor: "#D9D9D9",
    greenColor: "#0A8B5F",
    lightDangerColor: "#F11E1E",
    lightGrayColor: "#EFEFEF",
    primary: "#662D91",
    secondary: "#4BC6B9",
    background: "#F5F7FB",
    white: "#FFFFFF",
    black: "#1A1F36",
    cool: {
        teal: "#4BC6B9",
        light: "#E6FBF1",
        hover: "#13A697",
    },
    warm: {
        orange: "#FF6F61",
        light: "#F6F4FD",
        red: "#E33E38",
    },
    gray: {
        100: "#F7FAFC",
        200: "#EDF2F7",
        300: "#E2E8F0",
        400: "#CBD5E0",
        500: "#718096",
        600: "#4A5568",
        light: "#F4F4F4",
        lightMedium: "#D8D8D8",
        medium: "#969696",
        mediumDark: "#646464",
        dark: "#323232",
        grayText: "#B9B9B9",
        circle: "#9E9E9E",
    },
    basic: {
        textColor: "#4A4A4A",
        black: "#000000",
        white: "#ffffff",
    },
    hover: {
        purple: {
            100: "rgba(102, 45, 145, 0.1)",
            200: "rgba(102, 45, 145, 0.2)",
            300: "rgba(102, 45, 145, 0.3)",
            400: "rgba(102, 45, 145, 0.4)",
            500: "#47176C",
        },
    },
    error: "#FF4B4B",
    success: "#00C48C",
};
export const defaultColorPalette = Object.assign({ primaryColor: "#662d91", secondaryColor: "#729FFD", tertiaryColor: "#E9EBF6" }, othersColorPalette);
export const defaultFontFamilyConfig = {
    primaryFontFamily: "QuickSand",
    secondaryFontFamily: "Roboto",
};
export const defaultHelmet = {
    title: "Skill IQ",
    description: "Supercharge Your Career and Secure Your Dream Job with Skill IQ",
    favicon: "https://refactor-platform-store.objectstore.e2enetworks.net/0664a4e3-f010-466a-b13b-d3f28e0b6c28_FinalLogo_Favicon.png",
    thumbnailUrl: "https://refactor-platform-store.objectstore.e2enetworks.net/37a7be10-ec80-4ac7-99b2-7ebc01cea049_Skill_IQ_logo_purple_500px_X_500px_for white_background.png",
};
export const defaultBrandLogo = {
    whiteBgLogo: "https://refactor-platform-store.objectstore.e2enetworks.net/37a7be10-ec80-4ac7-99b2-7ebc01cea049_Skill_IQ_logo_purple_500px_X_500px_for white_background.png",
    darkBgLogo: "https://refactor-platform-store.objectstore.e2enetworks.net/2d16281d-1bf0-4038-be36-709dbdc8800a_FinalLogo_BlueBG_trimmed.png",
};
export const defaultDemoButtonConfig = {
    text: "Watch a demo",
    url: "https://youtu.be/xNHRfwIOyRY",
};
export const defaultQuotes = {
    brandLogoTags: "An AI Adaptive Interview Platform",
    headline: "Step into Your Dream Job",
    subHeadline: "Let our skill evaluation tools guide you.",
    demoBtn: defaultDemoButtonConfig,
};
export const defaultQuotesColor = {
    brandLogoTags: othersColorPalette.whiteColor,
    headline: othersColorPalette.whiteColor,
    brandingTag: othersColorPalette.whiteColor,
};
export const defaultChatbotConfig = {
    onInstruction: "false",
    onInterview: "false",
    onAdmin: "false",
};
export const defaultTenantConfig = {
    loginBgURL: "https://refactor-platform-store.objectstore.e2enetworks.net/af5dc733-f5db-4dc4-9667-066c08f67170_loginBg.png",
    quotes: defaultQuotes,
    quotesColor: defaultQuotesColor,
    brandLogo: defaultBrandLogo,
    colorPalette: defaultColorPalette,
    fontFamilyConfig: defaultFontFamilyConfig,
    helmet: defaultHelmet,
    isMaintenance: "false",
    category: ETenantCategory.CORPORATE,
    updatedAt: "21-12-2023-06:00:00:00pm",
    chatbotConfig: defaultChatbotConfig,
    showDashboard: "false",
    others: {
        showStrengths: "false",
    },
    isJdUserMatchEvaluated: "false",
    enableCategorizedJDs: "false",
    isConsultantAllowedToInviteUsersInPool: "false",
};
export const defaultTenantSettings = {
    id: 1,
    tenantName: "app",
    tenantConfig: defaultTenantConfig,
};
export const createTheme = (tenantSettings) => {
    return {
        colorPalette: Object.assign(Object.assign({}, defaultColorPalette), tenantSettings.tenantConfig.colorPalette),
        fonts: Object.assign({}, tenantSettings.tenantConfig.fontFamilyConfig),
    };
};
